import { cn } from "../lib/cn";
import { type Status, StatusDot } from "./status-dot";

const tone: Record<Status, string> = {
  ok: "bg-ok-subtle text-ok-fg",
  warn: "bg-warn-subtle text-warn-fg",
  err: "bg-err-subtle text-err-fg",
  neutral: "bg-surface-inset text-fg-muted",
  running: "bg-accent-subtle text-accent-fg",
};

/** Pill with dot + label. The label always carries the meaning; the dot is decoration. */
export function StatusBadge({
  status,
  children,
  className,
}: {
  status: Status;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-6 items-center gap-1.5 rounded-pill pr-2.5 pl-2 text-sm font-medium",
        tone[status],
        className,
      )}
    >
      <StatusDot status={status} />
      {children}
    </span>
  );
}

/** Inline status text with dot, for table cells. */
export function StatusText({
  status,
  children,
  className,
}: {
  status: Status;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 font-medium", className)}>
      <StatusDot status={status} />
      {children}
    </span>
  );
}
